import {Lesson, Task, Course, TestResult, TestSubmition, TEST_STATE} from "../../common/course";
import {ACTION_TYPES} from "./types";
export default {
    fetchCourses() {
        return {
            type: ACTION_TYPES.GET,
        }
    },
    fetchLessons(payload: string) {
        return {
            type: ACTION_TYPES.GET_LESSONS,
            payload,
        }
    },
    fetchLesson(payload: string) {
        return {
            type: ACTION_TYPES.GET_TASKS,
            payload,
        }
    },
    fetchTask(payload: string) {
        return {
            payload,
            type: ACTION_TYPES.GET_TASK,
        }
    },
    markTaskAsVisited(payload: {lessonId: Lesson['id'], taskId: Task['id']}) {
        return {
            payload,
            type: ACTION_TYPES.MARK_TASK_AS_VISITED,
        }
    },
    fetchTasksByCourseId(payload: Course['id']) {
        return {
            payload,
            type: ACTION_TYPES.GET_TASKS_BY_COURSE_ID,
        }
    },
    fetchTest(payload: string) {
        return {
            payload,
            type: ACTION_TYPES.GET_TEST_BY_ID,
        }
    },
    sendTestResults(payload: TestResult) {
        return {
            payload,
            type: ACTION_TYPES.SEND_TEST_RESULTS,
        }
    },
    getTestLastSubmition(payload: TestResult) {
        return {
            payload,
            type: ACTION_TYPES.GET_TEST_LAST_SUBMITION,
        }
    },
    setTestStatus(payload: {id: TestSubmition['id'], state: TEST_STATE}) {
        return {
            payload,
            type: ACTION_TYPES.CHANGE_TEST_STATUS,
        }
    }
}
